<template>
  <div>
    <div class="task-board" style="display: block" @click="openBox">
      <img src="@/assets/btn24.png" />
    </div>
    <taskBoard class="helper-wrap" v-show="isOpenBox" style="display: bolck" @openBg="openDragBox"></taskBoard>
    <draggable :visiable="isShowBusiBox" @closeDragBox="closeDragBox" :pane="pane" :videoId="videoId"></draggable>
  </div>
</template>

<script>
import Draggable from '@/components/Draggable'
import TaskBoard from '@/components/TaskBoard'
import { mapActions } from 'vuex'
import ossService from '@/utils/oss.service'

export default {
  name: 'Fade',
  components: {
    Draggable,
    TaskBoard,
  },
  data() {
    return {
      isOpenBox: false,
      isShowBusiBox: false,
      pane: {},
      videoId: '',
    }
  },
  created() {
    this.getBusinessList()
    ossService.Initialization()
  },
  methods: {
    openBox() {
      sessionStorage.setItem('str', 'asdlkasjd')
      sessionStorage.getItem('str')
      this.isOpenBox = !this.isOpenBox
    },
    closeOne() {
      this.isOpenBox = false
    },
    closeDragBox(val) {
      this.videoId = ''
      this.isShowBusiBox = val
    },
    openDragBox(val) {
      // console.log(`点击背景单据......${val}`)
      this.pane = val
      this.isShowBusiBox = true
      if (val.hasOwnProperty('videoId')) {
        this.videoId = val.videoId
      }
    },
    ...mapActions('practice', ['getBusinessList']),
  },
}
</script>
<style lang="less" scoped>
/*悬浮窗 */
.task-board {
  position: fixed;
  right: 10px;
  bottom: 20px;
  z-index: 9999;
}
/*第一个弹窗 */
.helper-wrap {
  border-radius: 3px 3px 3px 3px;
  position: fixed;
  bottom: 20px;
  // width: 290px;
  right: 50px;
  z-index: 9999;
  display: block;
  _position: absolute;
  _bottom: auto;
  // height: 188px;
  _top: auto;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.176);
}
.wrap-title {
  height: 38px;
  padding: 0 10px;
  line-height: 38px;
  background: #d4b562;
  cursor: move;
}
.wrap-title a {
  font-size: 14px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  float: right;
}
.close {
  font-size: 18px;
  font-style: normal;
  opacity: 1;
  line-height: 38px;
}
.download {
  margin-right: 8px;
}
h3,
.theme-popover .theme-poptit h3 {
  float: left;
  color: #fff;
  height: 100%;
  line-height: 38px;
  padding: 0;
  font-weight: normal;
  font-size: 14px;
  margin: 0;
}
.wrap-title a.reset {
  float: left;
  margin-left: 8px;
}
.helper-box {
  background: none repeat scroll 0 0 #fff;
  border: 5px solid #d4b562;
  position: relative;
  text-align: left;
  overflow: auto;
  height: 150px;
  z-index: 10000;
  font-size: 16px;
  padding: 5px 0;
  color: #fff;
  width: 100%;
  left: auto;
  box-sizing: border-box;
  border-width: 2px;
  border-top: none;
}
.helper-wrap .con-all-list {
  padding: 0;
}
.helper-wrap .helper-tab-con .con-all-list li.active {
  background: #c7c4c4;
}
.helper-wrap .helper-tab-con .con-all-list li {
  cursor: pointer;
}
.helper-wrap .con-all-list li {
  color: #000;
  font-size: 12px;
  list-style-type: none;
  line-height: 20px;
  padding: 0 5px;
  height: 30px;
  margin-top: 0;
  margin-left: 0;
  border-bottom: 1px dashed #ccc;
  list-style: none;
  a {
    color: #333;
    text-decoration: none;
  }
}
.helper-wrap .con-all-list li .liebtab {
  float: left;
  color: rgb(51, 51, 51);
  font-size: 13px;
  line-height: 30px;
}
.helper-wrap .con-all-list li .right-video {
  float: right;
  margin-top: 6px;
}
.helper-wrap .con-all-list li .fa.fa-check {
  margin-top: 8px;
  margin-left: 5px;
  color: #00b28e;
  padding: 0;
}
.helper-wrap .con-all-list li .fa-check {
  float: left;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fa-check:before {
  content: '\f00c';
}
/*第二个弹窗 */
.helper-question-wrap {
  border-radius: 3px 3px 3px 3px;
  position: fixed;
  right: 301px;
  bottom: 20px;
  width: 420px;
  height: 188px;
  z-index: 10;
  _position: absolute;
  _bottom: auto;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.176);
  _top: auto;
  display: none;
}
.helper-box {
  background: none repeat scroll 0 0 #fff;
  border: 5px solid #d4b562;
  position: relative;
  text-align: left;
  overflow: auto;
  height: 150px;
  z-index: 10000;
  font-size: 16px;
  padding: 5px 0;
  color: #fff;
  width: 100%;
  left: auto;
  box-sizing: border-box;
  border-width: 2px;
  border-top: none;
}
.helper-question-wrap .item p {
  font-size: 13px;
  color: #000;
  padding: 0 5px;
  line-height: 22px;
}
.page-red {
  color: red;
}
.helper-question-wrap .item p {
  font-size: 13px;
  color: #000;
  padding: 0 5px;
  line-height: 22px;
}
</style>
